const C = require("../constants");
const initial_data = {open: false, ticket:null};

function TicketClientDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.TICKET_CLIENT_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default TicketClientDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/TicketClientDialogReducer.js